module.exports = __webpack_public_path__ + "static/media/markerpin_pink.d58f4b00.svg";